// @ts-ignore
import D404 from '@stencil/d404';
import {setVerticalFooterData} from '@stencil/footer/src/footer-data';
import {getAndProcessFAQHomepageData} from '@stencil/gi-faq';
import {
  getHomeSeoMetaFromInmemory,
  setHomeSeoMetaToInMemory,
} from '@stencil/home-seo-meta-to-inmemory';
import {fillStoreForDetail, fillStoreForSRP} from '@stencil/hotels-fillstore';
import {hotelReviewActions} from '@stencil/hotels-review-reducer';
import logger from '@stencil/logger';
import {metaCookieName} from '../config/app-config';
import {appConfig} from '@stencil/hotels-config';
import {
  aerospikeIp,
  aerospikeNamespaceForHotels,
  aerospikeNamespaceForVoyager,
  aerospikePort,
} from '../config/infra-config';
import {updateQueryAction} from '@stencil/hotels-common-reducer/src/actions';
import {hotelsPartnerFn} from '@stencil/hotels-common-reducer/src/selectors';
import {IUpdate_Query} from '@stencil/hotels-common-reducer/src/types';
import DetailsPage from '../pages/DetailsPage/DetailsPage';
import {detailHttpCode, detailUrlFromStaticData} from '../pages/DetailsPage/selectors/index';
import parseDetailsPageUrlToConfig from '@stencil/hotels-utils/src/parse-details-page-url-to-config';
import HomePage from '../pages/HomePage/HomePage';
import {updateSEOData} from '../pages/HomePage/redux/actions';
import ReviewPage from '../pages/ReviewPage/ReviewPageChunk';
import parseReviewPageUrlToConfig from '@stencil/hotels-utils/src/parse-review-page-url-to-config';
import {updateSrpConfigAction} from '../pages/SRP/redux/actions';
import {ISrpConfig, ISrpQueryParams} from '../pages/SRP/redux/types';
import SRP from '../pages/SRP/SRP';
import {parseMetaUrlToConfig} from '../pages/SRP/utils/parseMetaUrlToConfig';
import {parseSrpUrlToConfig} from '../pages/SRP/utils/parseSrpUrlToConfig';
import {updateDetailsPageConfigAction} from './../pages/DetailsPage/redux/actions';
import {IUpdate_Details_Config_Action} from './../pages/DetailsPage/redux/types';
import {userReviewDetailType} from '@stencil/hotels-ugc-redux/src/hotels-ugc-actions';

import {updateSelectedProperty} from '@stencil/hotels-common-reducer/src/actions';

const serviceApp = 'avatar';

export default [
  {
    path: '/:partner/',
    component: HomePage,
    key: 'hotelsHomePage',
    traceVitalsConfig: {serviceApp, pageName: 'hotelsHomePage'},
    onServerInit: () => {
      setHomeSeoMetaToInMemory(['hotels_home_seo_meta', 'gostays_home_seo_meta'], false);
      setVerticalFooterData('hotel');
      getAndProcessFAQHomepageData('dh_home_json', false);
      getAndProcessFAQHomepageData('gostays_home_json_v2', false);
    },
    exact: true,
    populateStoreFromUrl: ({params, searchString}, dispatch) =>
      dispatch(
        updateQueryAction({
          partner: params.partner,
        } as IUpdate_Query['actionData']),
      ),
    fillStoreOnServer: ({state}) => {
      return updateSEOData(
        getHomeSeoMetaFromInmemory(
          hotelsPartnerFn(state) === 'hotels' ? 'hotels_home_seo_meta' : 'gostays_home_seo_meta',
        )?.desktop,
      );
    },
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({params}) => `${params.partner}_homepage`,
      // redisConfig: {
      //   host: redisConfig,
      //   port: redisPort,
      //   db: '1',
      //   ttl: 60 * 60 * 6, // 6 hours
      // },
      aerospikeConfig: {
        ip: aerospikeIp,
        port: aerospikePort,
        namespace: aerospikeNamespaceForVoyager,
        set: 'dhotels-homepage',
        ttl: 60 * 60 * 6, // 6 hours
      },
    },
  },
  {
    // '/:partner/find-hotels-in-:cityName/:cityId/:entityId/hotels-:garbageToSupportOldURL',
    path: '/:partner/find-hotels-in-:cityName?/:cityId/:entityId/:hotelQuery?',
    component: SRP,
    key: 'hotelSRP',
    traceVitalsConfig: {serviceApp, pageName: 'hotelsSRP'},
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const parsedSrpConfig = parseSrpUrlToConfig(searchString, params as ISrpQueryParams);
      const {
        filter,
        checkin,
        checkout,
        destination,
        roomString,
        metaPartner,
        country,
      } = parsedSrpConfig;
      dispatch(
        updateQueryAction({
          destination,
          checkin,
          checkout,
          roomString,
          partner: params.partner,
          metaPartner,
          country,
        } as IUpdate_Query['actionData']),
      );
      dispatch(updateSrpConfigAction(filter as ISrpConfig));
    },
    exact: true,
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({params}) => `hotels_dynamic_srp_${params.cityId}_${params.entityId}`,
      // redisConfig: {
      //   host: redisConfig,
      //   port: redisPort,
      //   db: '1',
      //   ttl: 60 * 60 * 6, // 6 hours
      // },
      aerospikeConfig: {
        ip: aerospikeIp,
        port: aerospikePort,
        namespace: aerospikeNamespaceForHotels,
        set: 'dhotels-srp',
        ttl: 60 * 60 * 6, // 6 hours
      },
    },
  },
  {
    path: [
      '/:partner/find-sem-hotels-in-:cityName?/:hotelNameSlug/:cityId/:hotelId(\\d+)/:hotelQuery?',
      '/:partner/meta/:metaPartner/:cityId/:hotelId?/:hquery?',
    ],
    component: SRP,
    key: 'hotelMetaSRP',
    traceVitalsConfig: {serviceApp, pageName: 'hotelsMetaSRP'},
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const parsedSrpConfig = parseMetaUrlToConfig(searchString, params);
      const {
        filter,
        checkin,
        checkout,
        destination,
        roomString,
        overriderankvhids,
        metaPartner,
        ibp,
        vendor,
      } = parsedSrpConfig;
      dispatch(
        updateQueryAction({
          destination,
          checkin,
          checkout,
          roomString,
          partner: params.partner,
        } as IUpdate_Query['actionData']),
      );
      dispatch(
        updateSrpConfigAction({
          ...filter,
          overriderankvhids,
          metaPartner,
          ibp,
          vendor,
        } as ISrpConfig),
      );
    },
    actionsBeforeRenderOnServer: ({
      params,
    }: {
      params: {
        metaPartner?: string;
        utm_campaign?: string;
        utm_source?: string;
        utm_medium?: string;
      };
    }) => {
      try {
        const cookies = [];
        const {metaPartner = 'google'} = params;
        const cookieName = metaCookieName;
        const today = new Date();
        const timeStamp = 24 * 60 * 60 * 1000;
        // const meta_partner = query && query.metaTraffic ? query.metaTraffic : '';
        // const metaPartner = params && params.metaPartner ? params.metaPartner : meta_partner;
        if (metaPartner) {
          // newrelic.addCustomAttributes({metaPartner});
          const {utm_campaign = ''} = params;
          let {utm_source = '', utm_medium = ''} = params || {};
          if (!utm_source || !utm_medium) {
            switch (metaPartner) {
              case 'google':
                utm_source = 'google';
                utm_medium = utm_medium ? utm_medium : 'cpc_hpa';
                break;
              case 'trivago':
                utm_source = 'meta';
                utm_medium = utm_medium ? utm_medium : 'Trivago_DH';
                break;
              case 'tripadvisor':
                utm_source = 'meta';
                utm_medium = utm_medium ? utm_medium : 'Tripadvisor_DH';
                break;
              default:
                utm_source = '(not set)';
                utm_medium = '(not set)';
            }
          }
          const cookieDataSm = utm_source + ' / ' + utm_medium + ' / ' + utm_campaign;
          const cookieData = {
            sm: cookieDataSm,
            t: today.getTime(),
          };

          cookies.push({
            name: cookieName,
            value: JSON.stringify(cookieData),
            options: {
              domain: '.goibibo.com',
              maxAge: timeStamp,
            },
          });
        } else {
          cookies.push({
            name: cookieName,
            value: JSON.stringify({sm: 'direct/none/NA', t: ''}),
            options: {
              domain: '.goibibo.com',
              maxAge: timeStamp,
            },
          });
        }
        return {cookies};
      } catch (err) {
        logger.error({
          type: 'cookie',
          label: 'metaCookie',
          msg: err,
        });
      }
    },
    exact: true,
  },
  {
    path: ['/:partner/nhotel-booking/'],
    component: ReviewPage,
    key: 'reviewPage',
    traceVitalsConfig: {serviceApp, pageName: 'hotelsReviewPage'},
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const parsedConfig = parseReviewPageUrlToConfig(searchString);
      dispatch(
        updateQueryAction({
          checkin: parsedConfig.checkin,
          checkout: parsedConfig.checkout,
          roomString: parsedConfig.roomString,
          destination: parsedConfig.destination,
          partner: params.partner,
          country: parsedConfig.country,
        } as IUpdate_Query['actionData']),
      );

      dispatch(
        updateSelectedProperty({
          payload: {
            ...parsedConfig.selectedProperty,
          },
        }),
      );

      dispatch(
        hotelReviewActions.updateDescblockInput({
          ...parsedConfig.input,
        }),
      );
    },
    exact: true,
    showHeader: true,
    showFooter: false,
  },
  {
    path: [
      '/:partner/:hotelNameSlug+-in-:cityName?-:hotelId(\\d+)/:hotelQuery?',
      '/:partner/detail/:cityName/:hotelName/:cityId/:hotelId/(:vendorId(/:hquery(/:fwdp(/:pricedet))))',
    ],
    component: DetailsPage,
    key: 'hotelDetails',
    traceVitalsConfig: {serviceApp, pageName: 'hotelsDetailsPage'},
    customTransactionForCacheHitTracing: true,
    populateStoreFromUrl: ({params, searchString}, dispatch) => {
      const parsedConfig = parseDetailsPageUrlToConfig(searchString, params);
      const searchQuery = new URLSearchParams(searchString);
      const pageString = searchQuery.get('page') || '1';
      const page = parseInt(pageString, 10);
      const {offset = 0, limit = 5} = page === 1 ? {} : {offset: 5 + (page - 2) * 25, limit: 25};
      dispatch(
        updateQueryAction({
          checkin: parsedConfig.checkin,
          checkout: parsedConfig.checkout,
          roomString: parsedConfig.roomString,
          partner: params.partner,
          metaPartner: parsedConfig.metaPartner,
          country: parsedConfig.country,
        } as IUpdate_Query['actionData']),
      );

      dispatch(
        updateSelectedProperty({
          payload: {
            propertyId: parsedConfig.hotelId,
            propertyName: parsedConfig.selectedHotelStatic.hn,
            hmd: parsedConfig.hmd,
            reviewType: parsedConfig.selectedHotelStatic?.reviewType,
          },
        }),
      );

      dispatch(
        updateDetailsPageConfigAction({
          ...parsedConfig,
          page,
        } as IUpdate_Details_Config_Action['actionData']),
      );
      dispatch(
        userReviewDetailType({
          offset,
          limit,
          tagIds: [],
          filter: '',
          sortBy: '',
          page,
        }),
      );
    },
    fillStoreOnServer: fillStoreForDetail,
    fillStoreWaitTime: 5000,
    exact: true,
    toBeCached: true,
    cacheConfig: {
      getCacheKey: ({params, searchString}) => {
        const searchQuery = new URLSearchParams(searchString);
        const pageString = searchQuery.get('page') || '1';
        return `hotels_detail_${params.hotelId}_${pageString}`;
      },
      // redisConfig: {
      //   host: redisConfig,
      //   port: redisPort,
      //   db: '2',
      //   ttl: 60 * 60 * 24 * 7, // 1 week
      // },
      aerospikeConfig: {
        ip: aerospikeIp,
        port: aerospikePort,
        namespace: aerospikeNamespaceForHotels,
        set: 'dhotels-detailsPage',
        ttl: 60 * 60 * 24 * 7, // 1 week
      },
    },
    actionsBeforeRenderOnServer: ({state, params, searchString}) => {
      let status = detailHttpCode(state);
      const {hotelNameSlug, cityName, hotelId, partner} = params;
      const hotel_url_from_request = `${hotelNameSlug}-in-${cityName}-${hotelId}`;
      const hotel_url = detailUrlFromStaticData(state) || hotel_url_from_request;
      let redirectUrl;
      if (hotel_url.toLowerCase() !== hotel_url_from_request.toLowerCase()) {
        redirectUrl = `/${partner}/${hotel_url}/${searchString}`;
        status = 301;
      }
      return {
        status,
        redirectUrl,
      };
    },
  },
  {
    // '/:partner/find-hotels-in-:cityName/:cityId/:entityId/hotels-:garbageToSupportOldURL',
    path: [
      '/:partner/intl-hotels-in-:cityName-ct/',
      '/:partner/intl-hotels-in-:cityName/:areaName-ah/',
      '/:partner/intl-hotels-in-:cityName/near-:landmark-lh/',
      '/:partner/intl-hotels-in-:cityName/:chainName-chain/',
      '/:partner/intl-:sortingType-hotels-in-:cityName-cg/',
      '/:partner/intl-:propertyType-in-:cityName-pt/',
      '/:partner/intl-:propertyType-in-:cityName/:areaName-ap/',
      '/:partner/intl-:propertyType-in-:cityName/near-:landmarkName-lp/',
      '/:partner/intl-hotels-for-:collectionName-in-:cityName/',
      '/:partner/intl-:collections-in-:cityName/',

      '/:partner/hotels-in-:cityName-ct/',
      '/:partner/hotels-in-:cityName/:areaName-ah/',
      '/:partner/hotels-in-:cityName/near-:landmark-lh/',
      '/:partner/hotels-in-:cityName/:chainName-chain/',
      '/:partner/hotels-for-:collectionName-in-:cityName/',
      '/:partner/hotels-in-:cityName-with-:amenity/',
      '/:partner/:sortingType-hotels-in-:cityName-cg/',
      '/:partner/:propertyType-in-:cityName-pt/',
      '/:partner/:propertyType-in-:cityName/:areaName-ap/',
      '/:partner/:propertyType-in-:cityName/near-:landmarkName-lp/',

      // '/:partner/:cityName/',
      // '/:partner/hotels-in-:cityName/',
      '/:partner/:collectionName-hotels-in-:cityName/',
      '/:partner/hotels-in-:cityName/cs-:collectionID-cl/', // collection segment
      '/:partner/:collections-in-:cityName/',

      // '/:partner/:popularFilter-in-:cityname/',
    ],
    component: SRP,
    key: 'hotelSEOSRP',
    traceVitalsConfig: {serviceApp, pageName: 'hotelsSEOSRP'},
    customTransactionForCacheHitTracing: true,
    getNameForCustomTransaction: ({fromCache, cacheBurst, screen, postData}) => {
      const data =
        (postData.data && typeof postData.data === 'string' && JSON.parse(postData.data)) || {};

      if (data?.template_type) {
        return `${screen}_cache:${fromCache}_cb:${cacheBurst}_${data?.template_type}`;
      }
      return `${screen}_cache:${fromCache}_cb:${cacheBurst}`;
    },
    populateStoreFromUrl: () => {},
    fillStoreOnServer: params => {
      const {srpAPIconfig} = appConfig;
      const {version, flavour} = srpAPIconfig.desktop;
      return fillStoreForSRP({...params, version, flavour});
    },
    fillStoreWaitTime: 100000,
    exact: true,
    toBeCached: false,
  },
  {
    path: '*',
    component: D404,
    key: 'hotels404',
  },
];
